import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`When a user starts browsing your website or app, PostHog automatically assigns them an `}<strong parentName="p">{`anonymous ID`}</strong>{`, which is stored locally. `}</p>
    <p>{`Provided you've `}<a parentName="p" {...{
        "href": "/docs/libraries/js/persistence"
      }}>{`configured persistence`}</a>{` to use cookies or `}<inlineCode parentName="p">{`localStorage`}</inlineCode>{`, this enables us to track anonymous users – even across different sessions.`}</p>
    <p>{`By calling `}<inlineCode parentName="p">{`identify`}</inlineCode>{` with a `}<inlineCode parentName="p">{`distinct_id`}</inlineCode>{` of your choice (usually the user's ID in your database, or their email), you link the anonymous ID and distinct ID together.`}</p>
    <p>{`Thus, all past and future events made with that anonymous ID are now associated with the distinct ID. `}</p>
    <p>{`This enables you to do things like associate events with a user from before they log in for the first time, or associate their events across different devices or platforms.`}</p>
    <details>
  <summary>Using identify in the backend</summary>
      <p>{`  Although you can call `}<inlineCode parentName="p">{`identify`}</inlineCode>{` using our backend SDKs, it is used most in frontends. This is because there is no concept of anonymous sessions in the backend SDKs, so calling `}<inlineCode parentName="p">{`identify`}</inlineCode>{` only updates person profiles. `}</p>
    </details>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      